import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState
} from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorContext } from "../components/GympinPagesProvider";
import {
    getFavorites,
    toggleFavorite as storageToggleFavorite
} from "./favoritesStorage";

export const FavoritesContext = createContext({
    favorites: [],
    count: 0,
    isFavorite: () => false,
    toggleFavorite: () => {}
});

export function FavoritesProvider({ children }) {
    const currentUser = useSelector((state) => state.auth?.user);
    const userId = currentUser?.Id ?? null;
    const error = useContext(ErrorContext);
    const navigate = useNavigate();
    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        setFavorites(getFavorites(userId));
    }, [userId]);

    const isFavorite = useCallback(
        (placeId) => {
            if (!userId || placeId == null) return false;
            return favorites.some((item) => item.Id === placeId);
        },
        [favorites, userId]
    );

    const toggleFavorite = useCallback(
        (place) => {
            if (!userId) {
                error?.showInfo?.({
                    message: "برای افزودن به علاقه‌مندی‌ها وارد حساب کاربری شوید"
                });
                navigate("/login");
                return;
            }
            if (!place?.Id) return;

            const result = storageToggleFavorite(userId, place);
            if (!result) return;

            setFavorites(result.list);
            if (result.added) {
                error?.showSuccess?.({ message: "به علاقه‌مندی‌ها اضافه شد" });
            } else {
                error?.showInfo?.({ message: "از علاقه‌مندی‌ها حذف شد" });
            }
        },
        [userId, error, navigate]
    );

    const value = useMemo(
        () => ({
            favorites,
            count: favorites.length,
            isFavorite,
            toggleFavorite
        }),
        [favorites, isFavorite, toggleFavorite]
    );

    return (
        <FavoritesContext.Provider value={value}>
            {children}
        </FavoritesContext.Provider>
    );
}

export function useFavorites() {
    return useContext(FavoritesContext);
}
